export default "__VITE_ASSET__BSNrbo_Q__"